// extracted by mini-css-extract-plugin
export default {"main":"AreaAssociado_main__s-jbF","svg":"AreaAssociado_svg__23nVL","svgReverse":"AreaAssociado_svgReverse__TKjH1","toggleButton":"AreaAssociado_toggleButton__HP4Rk"};